// TODO: change this enum to to a string type 'ruler' | 'rulerAnchored' | 'episodeMeasurement'
export enum Tool {
  ruler,
  rulerAnchored,
  episodeMeasurement,
  ruler2d,
}
